import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from 'src/store/reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['questionReducer', 'businessCase']
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default function createAppStore(preloadedState = {}) {
  const store = configureStore({
    reducer: persistedReducer,
    preloadedState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware({
        thunk: true
      }),
    devTools: process.env.NODE_ENV !== 'production'
  });

  const persistor = persistStore(store);
  return { store, persistor };
}
